var map = {
	"./bill.js": 62,
	"./dailyReport.js": 1094,
	"./dashboard.js": 343,
	"./down.js": 940,
	"./finance.js": 1095,
	"./good.js": 952,
	"./login.js": 1096,
	"./relative.js": 256,
	"./staff.js": 963,
	"./supportLangs.js": 1097,
	"./upload.js": 964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 897;